module.exports = __webpack_public_path__ + "static/olu-eletu-4112cbc1477d9e149033c5df66087e16.jpg";